module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CE1SDS/tc-custom/9781439677766.jpg?1704886584378",
      "alt": "This image is the cover for the book Cookie Table, The, American Palate"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cookie Table, The, American Palate\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("All you need is love and cookies. Everyone loves cookies, but the people of the Steel Valley take this love to another level. Nowhere else in America will you behold hundreds--or even thousands--of cookies piled high for events of all kinds. This is the regionally famous cookie table. But how did this tradition start? Why do residents of the Pittsburgh and Youngstown areas always create them not just for weddings but for birthdays, graduations, fundraisers, community events, and so much more? How did this once quaint local custom become a social media phenomenon? How are the cookies made, and how is a cookie table organized? Join author and cookie table enthusiast Alice Crosetto on a delectable journey through this beloved Steel Valley tradition.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alice J. Crosetto\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alice Crosetto was born and raised in Youngstown, Ohio. She remembers helping her mother bake the family's favorite Christmas cookies with her sisters, Norma and Joan. Clothespins, pecan tarts and small kolachy (kiffles to some) were just a few they made during Christmas break. Admittedly not raised with the cookie table tradition, Alice embraced it passionately in her adult years. When she wasn't baking, Alice received a BA in Latin and Greek and graduate degrees in English, curriculum and instruction and library science from Kent State University. She retired after forty years as an educator and librarian.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0